import * as React from 'react';

export default () => (
  <div>
    <h3>Page not found</h3>
  </div>
);



// WEBPACK FOOTER //
// ./src/my-app/no-match.tsx